import React, { useEffect, useState } from "react";
import { useStore } from "../../../stores/store";
import Carat from "../../Toolbar/Carat";
import { SecondaryLayer } from "../../../interfaces/layer";

const DropdownButton = (props: {
    groupLayer: SecondaryLayer;
    activeIds: string[];
    scrollTop: number;
}) => {
    if (!props.groupLayer.groupLayers || !props.groupLayer.groupLayers.length) {
        return null;
    }
    const dropdownListRef = React.useRef<HTMLDivElement>(null);
    const containerRef = React.useRef<HTMLDivElement>(null);
    const { toggleLayerVisibility, setLayerVisibility, getLayerVisibilityById } =
        useStore();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    useEffect(() => {
        if (!props.activeIds) return;
        if (isDropdownOpen && dropdownListRef.current) {
            dropdownListRef.current.scrollIntoView();
        }
        props.groupLayer.groupLayers?.forEach((layer) => {
            if (props.activeIds.includes(layer.id)) {
                setLayerVisibility(layer.id, true);
            } else {
                setLayerVisibility(layer.id, false);
            }
        });

    }, [isDropdownOpen, props.activeIds]);


    const isAnyLayerVisible = props.groupLayer.groupLayers?.some((layer) => {
        const isVisible = props.activeIds.includes(layer.id);
        return isVisible;
    });

    return (
        <div className="w-full py-1" ref={containerRef}>
            <div className="flex items-center h-7">
                <button
                    onClick={() => {
                        if (isAnyLayerVisible) {
                            props.groupLayer.groupLayers?.forEach((layer) => {
                                setLayerVisibility(layer.id, false);
                            });
                        } else {
                            setIsDropdownOpen((prev) => !prev);
                        }
                    }}
                    style={{
                        boxShadow: isAnyLayerVisible
                            ? "inset 0 0 10px rgba(0,0,0,.55), 0 2px 4px rgba(0,0,0,.25)"
                            : "",
                    }}
                    className={`btn-athena flex-1 py-1 rounded-r-none  ${isAnyLayerVisible ? "active" : ""
                        }`}
                >
                    <span className="pl-6">{props.groupLayer.title}</span>
                </button>
                <button
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    className="py-1 pr-2 btn-athena text-center rounded-l-none"
                >
                    <Carat color="white" />
                </button>
            </div>
            {isDropdownOpen && (
                <div
                    ref={dropdownListRef}
                    style={{
                        top: (containerRef.current?.offsetTop || 0) - props.scrollTop,
                        width: containerRef.current?.clientWidth,
                    }}
                    className="mt-9 absolute text-sm bg-white text-black rounded-md z-50 shadow-xl border border-gray-200"
                >
                    <ul>
                        {props.groupLayer.groupLayers.map((groupLayer, i) => (
                            <li key={i} className={`cursor-pointer text-center`}>
                                <button
                                    onClick={() => {
                                        props.groupLayer.groupLayers?.forEach((layer) => {
                                            setLayerVisibility(layer.id, false);
                                        });
                                        toggleLayerVisibility(groupLayer.id);
                                        setIsDropdownOpen(false);
                                    }}
                                    className={`w-full text-nowrap px-4 hover:bg-gray-700 hover:text-white py-1 ${getLayerVisibilityById(groupLayer.id)
                                        ? "bg-gray-700 text-white"
                                        : ""
                                        }`}
                                >
                                    {groupLayer.title}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};
export default DropdownButton;